import { defineFcm } from '../shared/factory';

export const FCM_PROMOTIONS_ENDPOINT_CACHE_PETITION_STATS = defineFcm('promotions_endpoint_cache_petition_stats')
	.asBoolean()
	.withDefault(false)
	.toConfig();
